export default __webpack_public_path__ + "static/media/Logo.c03ddced.png";